import React from 'react';
import './FactionElvesDescription.css';
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";
import {
  ELVES_SHOOTING_RANGE,
  ELVES_SIZE_FOR_SUPPLY,
  ELVES_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP
} from "../../../../configs/factions/elves";

const FactionElvesDescription = () => {
  const shootingMarginLeft = <img
    className="faction-description-icon faction-description-icon-margin-left" src="/img/icons/shooting.png"
    alt="Стрельба"
    title={'Стрельба'}
  />;
  const shooting = <img
    className="faction-description-icon"
    src="/img/icons/shooting.png"
    alt="стрельба"
    title={'Стрельба'}
  />;
  const shootingMarginLeftRight = <img
    className="faction-description-icon faction-description-icon-margin-right-left"
    src="/img/icons/shooting.png"
    alt="стрельба"
    title={'Стрельба'}
  />;
  const damage = <img
    className="faction-description-icon"
    src="/img/icons/damage.png"
    alt="Урон"
    title={'Урон'}
  />;
  const damageMarginLeft = <img
    className="faction-description-icon faction-description-icon-margin-left"
    src="/img/icons/damage.png"
    alt="Урон"
    title={'Урон'}
  />;
  const supply = <img
    className="faction-description-icon faction-description-icon-margin-right-left" src="/img/icons/supply.png"
    alt="Снабжение"
    title={'Снабжение'}
  />;
  const melee = <img
    className="faction-description-icon"
    src="/img/icons/barracks red.png"
    alt="Ближний бой"
    title={'Ближний бой'}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  const distance = <img
    className={'policy-description-icon'}
    src={'/img/icons/distance.png'}
    alt={'Дальность'}
    title={'Дальность'}
  />;

  const distanceValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={distance}
    icon={ELVES_SHOOTING_RANGE}
  />

  const shootingDamageValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right'}
    value={damage}
    icon={shooting}
  />

  const meleeDamageValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damage}
    icon={melee}
  />

  const size = <img
    className="faction-description-icon"
    src="/img/icons/unit size.png"
    alt="Размер отряда"
    title={'Размер отряда'}
  />;

  const sizeBarracksValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={ELVES_SIZE_FOR_SUPPLY}
    icon={size}
  />
  const sizeMilitaryCampValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right'}
    value={ELVES_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP}
    icon={size}
  />

  const barracks = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;
  const militaryCamp = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
    alt={'Лагерь'}
    title={'Лагерь'}
  />;

  const unitEnemy = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 enemy.png'}
    alt={'Отряд противника'}
    title={'Отряд противника'}
  />;

  const fortress = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/fortress_light.10136716.png'}
    alt={'Крепость'}
    title={'Крепость'}
  />;

  return (
    <>
      <div className="policy-description_line">
        Все {unit} могут {shootingMarginLeft}{distanceValueAndIcon}.
      </div>
      <div className="policy-description_line">
        {shootingDamageValueAndIcon} равен
        <span className={'text-war policy-description-icon-margin-right-left'}>
          1/2
        </span>
        от {meleeDamageValueAndIcon}.
      </div>


      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        {unit} не имеют штрафа к {damageMarginLeft}
      </div>
      <div className="policy-description_line">
        при {shootingMarginLeftRight} по {unitEnemy} в {fortress}.
      </div>

      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        В
        <span className={'text-supply policy-description-icon-margin-left-end'}>
          фазе Снабжения
        </span>
        {unit} со {supply} получает
      </div>
      <div className="policy-description_line">
        только {sizeBarracksValueAndIcon} на {barracks} ({sizeMilitaryCampValueAndIcon} смежно {militaryCamp}).
      </div>
    </>
  );
};

export default FactionElvesDescription;
